import React from 'react';
import { RoughWork } from '../../containers/rough-work';
import { useRoughWorkPage } from './hooks';

export const RoughWorkPage = () => {
	useRoughWorkPage();

	return <RoughWork />;
};
